import { ConversationPurposeEntity } from "@/types/conversation";

export enum EmailTemplateType {
  FOLLOWUP = "FOLLOWUP",
  MEETINGPREP = "MEETINGPREP",
}

// The built-in stock template lives server-side with no template row
// (POST /conversation/:id/email-followup without a templateId uses it, and
// GET /email-template/default 404s for users who never created one), so
// pickers need a static frontend-only entry to represent it. The label lives
// here because there is no server-side name for the built-in. Deliberately
// NOT called "default" — "default" means the user's settings default
// template; the built-in is Focal's stock output.
export const BUILT_IN_TEMPLATE_ID = "__built-in-default__";
export const BUILT_IN_TEMPLATE_LABEL = "Standard template";

export interface EmailTemplateEntity {
  id: string;
  firmId: string;
  userId: string;
  emailTemplateType: EmailTemplateType;
  name: string;
  template: string;
  default: boolean;
  purpose: ConversationPurposeEntity | null;
  createdAt: number;
  updatedAt: number;
}
